import { ErrorService } from 'shared-components';

const errorService = new ErrorService();
export default errorService;
